export default {
    categoryComment: {
        accountCategory: {
            displayText: 'Referência',
            value: 'EM GERAL',
        },
        chargeCategory: {
            displayText: 'Itens de cobrança',
        }
    },
    resolveText: 'Resolvido',
    tabsText: {
        preAudit: 'Pré auditoria',
        concurrent: 'Concorrente',
    },
    managementComments: {
        textDisplayButtonAddComment: 'Comentário geral',
        addCommentAccount: 'Adicionar comentário à conta',
        addCommentCharge: 'Adicionar comentário ao item de cobrança',
        editComment: 'Editar comentário',
        placeHolderValue: 'Adicionar comentário',
        textButtons: {
            accept: 'Aceitar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
        },
        deleteConfirmation: {
            title: 'Excluir Comentário de Auditoria',
            message: 'Tem certeza de que deseja excluir este comentário? Esta ação não pode ser desfeita e será registrada no histórico de auditoria.',
            cancel: 'Cancelar',
            confirm: 'Excluir'
        }
    },
    alertMessages: {
        createdComment: 'O comentário foi salvo com sucesso',
        editComment: 'O comentário foi editado com sucesso',
        deleteComment: 'O comentário foi excluído com sucesso',
        errorCommentMissing: 'Por favor insira um comentário antes de salvar',
        errorDefault: 'Ocorreu um erro ao gerenciar o comentário',
    }
}
